import { useNavigate } from "react-router-dom";
import { useUserProfile } from "@/contexts/UserProfileContext";
import { Eye, X, Database } from "lucide-react";

export default function ImpersonationBanner() {
  const { isImpersonating, impersonatedUser, stopImpersonation, openFhirDrawer } = useUserProfile();
  const navigate = useNavigate();

  if (!isImpersonating || !impersonatedUser) return null;

  const handleStop = () => {
    stopImpersonation();
    navigate("/admin/usuarios");
  };

  const displayName =
    impersonatedUser.name?.trim() ||
    impersonatedUser.email ||
    "usuario";

  return (
    <div
      data-testid="impersonation-banner"
      style={{
        background: "linear-gradient(135deg, #6D28D9 0%, #9333EA 50%, #C026D3 100%)",
        color: "white",
        padding: "10px 16px",
        fontSize: 13,
        fontWeight: 600,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontFamily: "Inter, sans-serif",
        boxShadow: "0 2px 8px rgba(109, 40, 217, 0.25)",
        position: "sticky",
        top: 0,
        zIndex: 50,
      }}
    >
      <span className="flex items-center gap-2 min-w-0">
        <Eye size={16} className="shrink-0" />
        <span className="truncate">
          Navegando como{" "}
          <strong className="font-bold">{displayName}</strong>
          {impersonatedUser.email && (
            <span
              className="ml-2 hidden sm:inline"
              style={{ color: "rgba(255,255,255,0.75)", fontWeight: 400 }}
            >
              · {impersonatedUser.email}
            </span>
          )}
          <span
            className="ml-2 text-[10px] uppercase tracking-wider hidden sm:inline-block px-1.5 py-0.5 rounded"
            style={{ background: "rgba(255,255,255,0.2)" }}
          >
            Solo lectura
          </span>
        </span>
      </span>
      <div className="flex items-center gap-2 shrink-0">
        <button
          onClick={openFhirDrawer}
          data-testid="impersonation-fhir-btn"
          className="flex items-center gap-1.5 cursor-pointer shrink-0"
          style={{
            background: "rgba(255,255,255,0.22)",
            border: "1px solid rgba(255,255,255,0.35)",
            borderRadius: 6,
            padding: "4px 10px",
            fontSize: 11,
            fontWeight: 600,
            color: "white",
          }}
          title="Abrir consola de auditoría FHIR para este usuario"
        >
          <Database size={12} className="text-teal-300" />
          <span>Auditoría FHIR</span>
        </button>
        <button
          onClick={handleStop}
          data-testid="impersonation-exit-btn"
          className="flex items-center gap-1 cursor-pointer shrink-0"
          style={{
            background: "rgba(255,255,255,0.22)",
            border: "1px solid rgba(255,255,255,0.35)",
            borderRadius: 6,
            padding: "4px 12px",
            fontSize: 11,
            fontWeight: 600,
            color: "white",
          }}
        >
          <X size={12} />
          Salir
        </button>
      </div>
    </div>
  );
}

